'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { markInAppNavigation } from '@/app/helpers/navigationDepth';

export default function NavigationDepthTracker() {
    const pathname = usePathname();
    const isInitialRef = useRef(true);

    useEffect(() => {
        if (isInitialRef.current) {
            isInitialRef.current = false;
            return;
        }
        markInAppNavigation();
    }, [pathname]);

    return null;
}
